import {
  VrsCallCommentsRedirectingMenuButton,
  VrsCallCommentsTimer,
} from 'features/call/vrs-call-comments/components';
import { VrsBaseHeader } from 'features/call/vrs-call/components';
import { MenuButtons } from 'features/menu/components';
import { SettingsMenuButtonContainer } from 'features/settings/components';
import { CallIdPrevious } from 'features/ui/call-id';

export const VrsCallSurveyHeader = () => {
  return (
    <VrsBaseHeader
      callTimer={<VrsCallCommentsTimer />}
      callId={<CallIdPrevious />}
    >
      <MenuButtons>
        <VrsCallCommentsRedirectingMenuButton />
        <SettingsMenuButtonContainer />
      </MenuButtons>
    </VrsBaseHeader>
  );
};
